module.exports = __webpack_public_path__ + "img/online-mentoring.dfbedc51.png";